<template>
    <div class="board" >
      <div class="md-raised col" v-for="word in words" :key="word.key">
        <GameBoardButton 
        v-on:word-selected="buttonClicked" v-bind:word="word" />
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GameBoardButton from './GameBoardButton.vue'

export default {
  name: 'GameBoard',
  data: () => ({
    sending: false,
    spyMasterSelectionToolTip: false
  }),
  computed: {
    ...mapGetters({
      words: 'gameWords',
      permissions: 'hasViewPermission'
    })
  },
  methods: {
   wordColor(word, color) {
     return word.color === color && (!!word.clicked)
   },
   buttonClicked: (word) => {
     if(word){
        this.sending = true;

        // TODO make this async so we can be sure when it sends successfully,
        this.$store.dispatch({
            type: 'wordSelected',
            word
        });
      this.sending = false;
     } else {
       console.error("word was not defined..");
     }
   }
  },
  components: {
    GameBoardButton
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.board {
  display: flex;
  flex-wrap: wrap;
  width: 30rem;
  height: 30rem;
}
.board .col {
  flex: 1;
}
</style>